var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container-brand"},_vm._l((_vm.brandItem.store_list),function(item){return _c('div',{staticClass:"brand-item-container"},[_c('StoreItem',{attrs:{"item":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }